import { render, staticRenderFns } from "./hints.vue?vue&type=template&id=17d20273"
import script from "./hints.vue?vue&type=script&lang=js"
export * from "./hints.vue?vue&type=script&lang=js"
import style0 from "./hints.vue?vue&type=style&index=0&id=17d20273&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports